import React from 'react';
import mediaFolder from '../../assets/icons/signage-plus/media-folder.svg';
import pngIcon from '../../assets/icons/signage-plus/png-icon.svg';
import jpgIcon from '../../assets/icons/signage-plus/jpg-icon.svg';
import mp4Icon from '../../assets/icons/signage-plus/mp4-icon.svg';
import mp3Icon from '../../assets/icons/signage-plus/mp3-icon.svg';
import pdfIcon from '../../assets/icons/signage-plus/pdf-icon.svg';
import gifIcon from '../../assets/icons/signage-plus/gif-icon.svg';

function MediaAccordion({ tabData, onDragStart }) {
  const topLevelItems = tabData.filter((item) => item.subcategory === 'folder');
  const childItems = tabData.filter((item) => item.subcategory === 'file');

  return (
    <div className="accordion accordion-body-scroll pb-3" id="accordionPanelsStayOpenExample">
      {topLevelItems && topLevelItems.length > 0 && topLevelItems.map((item, idx) => (
        <div className="accordion-item" key={item.id}>

          <h2 className="accordion-header" id={`panelsStayOpen-heading${item.id}`}>
            <button
              className={`accordion-button playlist-accordion-title list-group-item collapsed`}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#panelsStayOpen-collapse${item.id}`}
              aria-expanded="false"
              aria-controls={`panelsStayOpen-collapse${item.id}`}
            >
              <img src={mediaFolder} alt="" className="icon icon-24 me-3" />
              <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: /*'nowrap'*/'pre', width: 'calc(100% - 70px)' }} title={item.name}>{item.name}</span>
            </button>
          </h2>
          <div
            id={`panelsStayOpen-collapse${item.id}`}
            className={`accordion-collapse collapse`}
            aria-labelledby={`panelsStayOpen-heading${item.id}`}
          >
            <div className="">
              {childItems.filter((child) => child.parentId === item.id).map((child) => {
                const typeToIconMap = {
                  png: pngIcon,
                  jpg: jpgIcon,
                  mp4: mp4Icon,
                  mp3: mp3Icon,
                  pdf: pdfIcon,
                  gif: gifIcon,
                };

                const iconSrc = typeToIconMap[child.type] || pngIcon;
                const rowStyle = {
                  cursor: onDragStart ? 'grab' : 'default',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'pre',
                  width: 'calc(100% - 50px)',
                };

                return (
                  <div
                    key={child.id}
                    className="media-content-row playlist-accordion-title d-flex align-items-center"
                    draggable
                    onDragStart={() =>
                      onDragStart &&
                      onDragStart(
                        child,
                        'media'
                      )
                    }
                    style={{ cursor: rowStyle.cursor }}
                  >
                    <img src={iconSrc} alt="" className="icon icon-24 me-3" />
                    <span
                      className="ms-2"
                      style={rowStyle}
                      title={child.name}
                    >
                      {child.name}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default MediaAccordion;
